import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { McpTool } from "../models/McpTool";

export const useCreateMcpTool = () => {
  const {
    data: createdTool,
    call,
    isLoading: isCreating,
    isFailed: isCreateFailed,
  } = useApiPrivateRequest<McpTool>((response) => new McpTool(response));

  const createMcpTool = async (
    name: string,
    url: string,
    authorizationToken?: string,
  ) => {
    await call(`/llm/mcpTools`, "POST", undefined, {
      name,
      url,
      authorizationToken,
    });
  };

  return {
    createdTool,
    createMcpTool,
    isCreating,
    isCreateFailed,
  };
};
